import {RouteConfig} from 'vue-router';
import { PermissionTypeEnum } from '../Api';
import Dashboard from '../dashboard/pages/Dashboard.vue';

export default [
    {
        path: '/:tenantId/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        props: (route) => ({tenantId: route.params.tenantId}),
        meta: {
            //permissions: [ PermissionTypeEnum.PerformAudit ],
            checkLicence: true,
            title: "menu.dashboard"
        }
    }
] as RouteConfig[];
